var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28.438,
    viewBox: "0 0 25 28.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14144",
    "data-name": "Group 14144",
    transform: "translate(-780.445 -335.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    d: "M791.675,621.515c-.413-.038-.826-.079-1.24-.114a22.325,22.325,0,0,1-5.814-1.2,8.219,8.219,0,0,1-2.908-1.636,4.844,4.844,0,0,1-.962-1.219,2.732,2.732,0,0,1,.423-3.093,6.9,6.9,0,0,1,2.855-1.95c.709-.284,1.446-.483,2.165-.739.191-.068.275-.008.375.161q1.991,3.369,3.993,6.73a2.7,2.7,0,0,0,2.143,1.46,2.5,2.5,0,0,0,2.456-1.2c.7-1.1,1.35-2.241,2.02-3.366.714-1.2,1.431-2.4,2.134-3.607a.306.306,0,0,1,.422-.171,13.486,13.486,0,0,1,3.59,1.474,5.2,5.2,0,0,1,1.642,1.538,2.82,2.82,0,0,1-.229,3.433,7.088,7.088,0,0,1-2.576,1.824,19.03,19.03,0,0,1-5.48,1.432c-.734.094-1.475.132-2.212.2a2.264,2.264,0,0,0-.242.048Z",
    transform: "translate(0 -257.205)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    d: "M828.454,344.963a9.145,9.145,0,0,1,2.579-6.4,8.777,8.777,0,0,1,11.208-1.195,8.783,8.783,0,0,1,3.734,5.332,8.948,8.948,0,0,1-1.126,7.142q-3.331,5.334-6.7,10.642a1.4,1.4,0,0,1-.492.482.768.768,0,0,1-1.03-.386q-1.03-1.629-2.052-3.263c-1.581-2.515-3.169-5.026-4.741-7.548A8.832,8.832,0,0,1,828.454,344.963Zm12.953-.005a4.048,4.048,0,1,0-4.063,4.117A4.1,4.1,0,0,0,841.407,344.957Z",
    transform: "translate(-44.406 0)",
    fill: "#ffbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.115cb17ebacdbfa0aeed057fc97775c4.svg";
export { ForwardRef as ReactComponent };